import { Button, ButtonProps, ElementProps } from '@mantine/core';
import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { Player } from 'shared/api';
import { breakpoints, ModalFormModel } from 'shared/lib';
import ActivateIcon from 'shared/ui/assets/activate-icon.svg?react';
import { ActivatePromocodeModel } from '../../model';

export type ActivatePromocodeButtonProps = ButtonProps &
	ElementProps<'button', keyof ButtonProps> & {
		modalData: Player;
		'data-test-id'?: string;
	};

export const createActivatePromocodeButton = (
	activateModel: ActivatePromocodeModel,
	cancelModel: Pick<ModalFormModel<Player>, 'modalButtonClicked'>,
) => {
	const ActivatePromocodeButton = forwardRef<HTMLButtonElement, ActivatePromocodeButtonProps>(
		({ modalData: player, className, onClick, ...props }, ref) => {
			const [activateClicked, cancelClicked, md] = useUnit([
				activateModel.modalButtonClicked,
				cancelModel.modalButtonClicked,
				breakpoints.md,
			]);

			const hasActivePromocode = player.voucherItem !== null;

			return (
				<Button
					ref={ref}
					className={className}
					data-test-id='activate-promocode-button'
					size={md ? 'lg' : 'md'}
					variant={hasActivePromocode ? 'destructive' : 'success'}
					onClick={(event) => {
						if (hasActivePromocode) {
							cancelClicked(player);
						} else {
							activateClicked(player);
						}

						onClick?.(event);
					}}
					{...props}
				>
					<ActivateIcon
						width={md ? 24 : 16}
						height={md ? 24 : 16}
					/>
				</Button>
			);
		},
	);

	return ActivatePromocodeButton;
};
